/**
 * 根据企业id获取某一层级下的所有部门
 */
import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';
import { IDepartListInfo } from './interface';
import { DEPARTMENT_ACCESS } from '@umu/umu-types';

export interface IDepartByLevel {
    department_id: string | number;
    level: number;
    type?: DEPARTMENT_ACCESS;
}

export const getDepartmentListByLevel = (data: IDepartByLevel): Promise<IResponse<IDepartListInfo>> => {
    if (!data.type) {
        delete data.type;
    }
    return fetchData(Api.GET_ALL_BYLEVEL, data).then((res: IResponse<IDepartListInfo>) => {
        return res;
    });
};
